.gb{border:1px solid #ddd;}